<template>
  <div
    v-if="visible"
    class="alert fade in"
    :class="[`alert-${type}`]"
  >
    <button
      v-if="dismissible"
      type="button"
      class="close"
      title="Close this alert"
      aria-hidden="true"
      @click="$emit('close')"
    >×</button>

    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    dismissible: {
      default: true,
      type: Boolean,
    },
    type: {
      default: 'error',
      type: String,
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style scoped>
.close {
  background-color: inherit;
  border: 0;
}
</style>